import React, { useEffect } from 'react';
import { useForm, useWatch } from 'react-hook-form';
import { X, Save } from 'lucide-react';
import { employesApi } from '../../utils/api';
import { differenceInBusinessDays, parseISO } from 'date-fns';

export default function CongesForm({ employes, onClose, onSaved }) {
  const { register, handleSubmit, control, setValue, formState: { isSubmitting } } = useForm({
    defaultValues: {
      type: 'cp',
      statut: 'en_attente',
    },
  });

  const dateDebut = useWatch({ control, name: 'date_debut' });
  const dateFin = useWatch({ control, name: 'date_fin' });

  useEffect(() => {
    if (dateDebut && dateFin) {
      try {
        const d1 = parseISO(dateDebut);
        const d2 = parseISO(dateFin);
        if (d2 >= d1) {
          const jours = differenceInBusinessDays(d2, d1) + 1;
          setValue('jours', jours > 0 ? jours : 1);
        }
      } catch {}
    }
  }, [dateDebut, dateFin, setValue]);

  const onSubmit = async (data) => {
    try {
      await employesApi.createAbsence(data);
      onSaved();
    } catch (err) {
      alert('Erreur lors de la création');
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-md">
        <div className="flex items-center justify-between p-5 border-b">
          <h2 className="font-semibold text-gray-800">Nouvelle absence</h2>
          <button onClick={onClose} className="p-1.5 rounded hover:bg-gray-100">
            <X size={18} />
          </button>
        </div>
        <form onSubmit={handleSubmit(onSubmit)} className="p-5 space-y-4">
          <div>
            <label className="form-label">Employé *</label>
            <select {...register('employe_id', { required: true })} className="form-select">
              <option value="">— Sélectionner —</option>
              {employes.map(e => (
                <option key={e.id} value={e.id}>
                  {e.prenom} {e.nom} — {e.structure_nom}
                </option>
              ))}
            </select>
          </div>
          <div>
            <label className="form-label">Type d'absence</label>
            <select {...register('type')} className="form-select">
              <option value="cp">Congés payés légaux (CP)</option>
              <option value="cp_anciennete">Congés ancienneté (+5j si &ge; 2 ans)</option>
              <option value="recup">Récupération</option>
              <option value="maladie">Maladie</option>
              <option value="formation">Formation</option>
              <option value="autre">Autre</option>
            </select>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="form-label">Date de début</label>
              <input type="date" {...register('date_debut', { required: true })} className="form-input" />
            </div>
            <div>
              <label className="form-label">Date de fin</label>
              <input type="date" {...register('date_fin', { required: true })} className="form-input" />
            </div>
          </div>
          <div>
            <label className="form-label">Nombre de jours (ouvrés)</label>
            <input
              type="number"
              step="0.5"
              {...register('jours')}
              className="form-input"
              readOnly
            />
          </div>
          <div>
            <label className="form-label">Statut</label>
            <select {...register('statut')} className="form-select">
              <option value="en_attente">En attente</option>
              <option value="approuve">Approuvé</option>
            </select>
          </div>
          <div>
            <label className="form-label">Commentaire</label>
            <textarea {...register('commentaire')} className="form-input" rows={2} />
          </div>
          <div className="flex gap-3 pt-2">
            <button type="submit" disabled={isSubmitting} className="btn-primary">
              <Save size={15} /> {isSubmitting ? 'Enregistrement...' : 'Enregistrer'}
            </button>
            <button type="button" onClick={onClose} className="btn-secondary">Annuler</button>
          </div>
        </form>
      </div>
    </div>
  );
}
